var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "TwoDView" }, [
    _c(
      "div",
      { ref: "fullCanvas", staticClass: "fullCanvas" },
      [
        _c("FlatPageView", {
          attrs: {
            "page-model": _vm.pageModel,
            scaling: _vm.fullScale,
            "show-mask": true,
            "show-overlay": true,
          },
          on: { painted: _vm.painted },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "space2d" }, [
      _c("canvas", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.showLoader,
            expression: "!showLoader",
          },
        ],
        ref: "canvas2d",
        attrs: { width: _vm.imageWidth, height: _vm.imageHeight },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showLoader,
              expression: "showLoader",
            },
          ],
          staticClass: "loaderBox",
          style: {
            height: _vm.imageHeight + "px",
          },
        },
        [
          _c(
            "svg",
            {
              staticClass: "loadIconSvg",
              attrs: { viewBox: "0 0 32 32", width: "64", height: "64" },
            },
            [
              _c("circle", {
                staticClass: "loadIcon",
                attrs: { cx: "16", cy: "16", r: "14", fill: "none" },
              }),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }